export default __webpack_public_path__ + "media/images/wing_right-febd32d4bb5b7f99a7cb7b40f5a242cd.png";